import { Lobby, Player, WsUpdateRequestData } from "common"
import { BACKGROUND_SHADE_T1, TOPIC_HEIGHT, TOPIC_WIDTH } from "../../utilities/Constants"
import { LoadingSpinner } from "../LoadingSpinner"

export function TopicsPanel(props: {
	lobby: Lobby,
	player: Player | undefined
	sendWsUpdate: (data: WsUpdateRequestData) => void
}) {

	function onClickReset() {
		props.sendWsUpdate({
			lobbyId: props.lobby.id,
			resetRound: true
		})
	}

	return <div style={{display: "flex", flexDirection: "column", alignItems: "stretch", gap: 10}}>
		<div style={{
			display: "grid",
			gridTemplateColumns: `repeat(auto-fit, minmax(${TOPIC_WIDTH}, 1fr))`,
			gap: 10
		}}>
			{
				props.lobby.topics !== undefined ? (
					props.lobby.topics.map(topic => <div key={topic} style={{
						height: TOPIC_HEIGHT, padding: 20, backgroundColor: BACKGROUND_SHADE_T1, fontSize: "large",
						display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", borderRadius: 4
					}}>{topic}</div>)
				) : (
					<LoadingSpinner/>
				)
			}
		</div>
		{
			props.lobby.players.findIndex(x => x.connectionId === props.player?.connectionId) === 0 ? (
				<div style={{cursor: "pointer", backgroundColor: BACKGROUND_SHADE_T1, borderRadius: 4, padding: 20, fontSize: "large", fontWeight: "bold", textAlign: "center"}} onClick={onClickReset}>RESET</div>
			) : (
				undefined
			)
		}
	</div>
}